import QwertyPortraitLayout from "./QwertyPortraitLayout";
import PropTypes from "prop-types";

const Keys = ({
  className = "",
  appearance = "Light",
  state = "Lowercase Letters",
}) => {
  return (
    <div
      className={`flex flex-col items-start justify-start text-center text-6xl text-light-text1 font-text-regular-lowercase ${className}`}
      data-appearance={appearance}
      data-state={state}
    >
      <QwertyPortraitLayout appearance="Light" state="Lowercase Letters" />
    </div>
  );
};

Keys.propTypes = {
  className: PropTypes.string,

  /** Variant props */
  appearance: PropTypes.number,
  state: PropTypes.number,
};

export default Keys;
